<template>
  <div 
    :style="`max-height : ${boxwrapperheight};`"
    class="fzmOrderBoxes">

        <template v-for="(order, index) in orderboxes">
            <div 
                @click="$emit('update:activebox', index)"
                :key="index"
                :class="['orderBox', {'active' : index == activebox}, {'complete' : order.flavors.length == 12}]">
                <span class="orderBoxLabel">
                    BOX
                </span>

                <span class="orderBoxNumber">
                </span>

                <span class="checkIcon">
                    <b-icon icon="check-circle"></b-icon>
                </span>

                <span 
                    v-if="orderboxes.length > minbox"
                    @click="removeorderbox(index)"
                    class="deletebtn">
                    <b-icon icon="x-circle"></b-icon>
                </span>
            </div>
        </template>

        <div 
            @click="addmorebox"
            class="addMoreBox">
            <b-icon icon='plus-circle-fill'></b-icon>
        </div>
        
        <div 
            :disable="!orderboxescomplete"
            @click="nextprocess"
            :class="['buyNow', {'disable' : !orderboxescomplete}] ">
            {{$route.name == 'product' ? 'BUY NOW' : 'UPDATE'}}
        </div>

      
</div>
</template>

<script>
// mixins
import {ordermixins} from '@/mixins/ordermixins'
import {orderboxmixins} from '@/mixins/orderboxmixins'

// plugins

export default {
    mixins: [ordermixins, orderboxmixins],
    props : {
        /**
         * active box will have default first box open
         */
        activebox : {
            type : Number,
            default: () => {
                return 0;
            }
        }
    },  
    data() {
        return {
            boxwrapperheight : 'calc(100vh-76px)'
        }
    },
    computed : {
        /**
         * Network status
         */
        isoinline(){
            return this.$store.state.isonline
        },
        /**
         * Previous page route data
         */
        routefrom() {
            return this.$store.state.routefrom
        },
        /**
         * Order type
         */
        issubscription() {
            return this.$store.state.issubscription
        },
        /** 
         * Subscriptoin list
        */
        subscriptions() {
            return this.$store.state.subscriptions
        },
        /**
         * User will have min order of boxes that cannot be deleted
         */
        minbox(){
            return this.$store.state.minbox
        },
        /**
         * User orders subscription boxes
         * flavors return id's only
         */
        orderboxes : {
            get() {
                const flavorids = this.flavors.map(f => f.id)

                return this.$store.state.orderboxes.map(box => {
                    /**
                     * Get flavor's id
                     * and check if falvors is available
                     */
                    box.flavors = box.flavors.map(f => typeof f == 'object' ? f.id : f)
                    box.flavors = box.flavors.filter(f => flavorids.includes(f))
                    return box;
                })
            },
            set(list) {
                this.$store.commit('updateorderboxes', list);
            }
        }
    },
    methods : {
         /**
         * Get flavor details container height
         */
        flavordetailscontainerheight() {
            const flavorcont  = document.querySelector('.fzmProductPage')
            // const fillboxcont = document.querySelector('.fillboxwrapper')

            if(flavorcont) {
                this.boxwrapperheight =  `${flavorcont.clientHeight - 120}px`
            } 
        },
        /**
         * Next process
         * if new subscription it will redirect to check out
         * if for update call update function
         */
        nextprocess() {
            if(this.$route.name == 'product') {
                this.$router.push({name : 'checkout'})
            } else {
                this.$router.push({name : 'orderschedule', params : {edit : true}})
            }
        },
        
        /**
         * Get minimum order for subscription
         */
        getminsubsorder(){
            const minsettings = this.settings.find(sett => sett.settings_field.match(/subscription_minimum_order/g))
            this.$store.commit('updateminsubsorder', minsettings ? parseInt(minsettings.settings_value) : 3)
        },
         /**
         * Check if user has subscription
         * if none 
         * default number of boxes will be 3
         * prevent from running if page from is checkout
         * 
         * reset card details
         */
        defaultboxes() {
            // check order type subscription or event
            this.$store.commit('updateordertype', true);

            if(this.routefrom.name != 'checkout') {
                if(this.issubscription && this.$route.name == 'product') {
                    /**
                     * newboxproperty function have option to return with default box type
                     */
                    const resetboxes      = Array.from({length : this.minbox}, () => (this.newboxproperty(true, 'subscription')));
                          this.orderboxes = resetboxes;
                } else {
                    /**
                     * If has subsciptoins get order boxes
                     */
                    const [sub] = this.subscriptions;
                    if(sub) {
                        this.$store.dispatch('getsubboxitems', sub.id)
                    }
                }

                this.$store.commit('updatecarddetails', null);
            }
        },
         /**
         * Remove order box
         * this will be available if more than min box requirements
         */
        removeorderbox(index) {
            this.orderboxes.splice(index, 1)
        },
        /**
         * Addmore order box 
         */
        addmorebox() {
            this.setflagboxchange('boxitem');
            this.orderboxes = [...this.orderboxes, this.newboxproperty(true, 'subscription')];
        }
    },
    /**
     * Run function before component redered
     */
    async beforeMount() {
        // Boxes type
        await this.$store.dispatch('getboxtypes');
        // Get flavors
        await this.$store.dispatch('getflavors');
        // Get min order
        this.getminsubsorder();
        // default boxes
        this.defaultboxes(); 

        this.flavordetailscontainerheight();
    },
    /**
     * Run function after component rendered
     */
    mounted() {
        this.flavordetailscontainerheight();
    }
}
</script>

<style lang="scss"> 
@import '@/scss/_settings.scss';
@import '@/scss/global/_mixins.scss';
.fzmProductPage {
    .fzmOrderBoxes {
        max-height   : calc(100vh - 76px);
        overflow     : hidden auto;
            
        @include screen-up(sm) {
            max-height: calc(100vh - 280px);
            margin-top: 30px;
        }

        .complete {
            .deletebtn {
                right: -60px;
            }
        }

        .deletebtn {
            position : absolute;
            right    : -25px;
            color    : $primary-color;
            font-size: 20px;
        }

        .disable {
            pointer-events: none;
        }
    }

}

</style>